import { manifestSizes } from "global/components/imaging/createManifestIcons";
import { grts, responseReducers } from "./reducerHelpers/dispatchProps";

const rts = {
  handleAmmend_currentManifest: 'handleAmmend_currentManifest',
  ...grts
}

export const manifestInitialState = (initState) => {
  return { ...initState, piElemsCache: new Map() }
};

export const manifestReducer = (state, action) => {

  const { type } = action

  switch (type) {
    case rts.handleAmmend_currentManifest:
      const { manifests, settingsGlobal, settingsDocName } = action
      const mz = {}
      _.forEach(manifests, (url, key) => {
        try {
          const _key = key
          const index = _key.replace('manifest_', '')
          const _url = url
          mz[_key] = {
            size: manifestSizes[index], fileUrl: _url
          }
        } catch (error) {

        }
      })
      const startIcon = {
        size: manifestSizes[0],
        fileUrl: mz['manifest_0']
      }
      return { ...state, manifestIcons: mz, startIcon, settingsGlobal, manifestDocName: settingsDocName }

    case rts.updateSuccess:
    case rts.updateSuccessAlt:
    case rts.updateError:
      return responseReducers(state, action, { questionProps: null })

    default:
      return { ...state }
  }
}

export const manifestHandlers = (dispatch) => {
  return {
    handleAmmend_currentManifest: (manifests, settingsGlobal, settingsDocName) => { dispatch({ type: rts.handleAmmend_currentManifest, dispatch, manifests, settingsGlobal, settingsDocName }) },
  }
}
